import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export default function Footer() {
  const { t } = useTranslation("home");

  return (
    <footer className="bg-text w-full">
      <div className="w-full px-4 md:px-6 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-white/60 text-sm">
          {t("footer.copyright")}
        </p>
        <a
          href="https://www.detalleweb.com.mx/"
          target="_blank"
          rel="noopener noreferrer nofollow"
          className="text-white/60 text-sm hover:text-magenta transition-colors"
        >
          {t("footer.developed")}
        </a>
      </div>
    </footer>
  );
}